import { FC } from 'react';

import classes from './Contact.module.scss';
import Heart from '../../assets/heart.png';
import { Button, message, Modal } from 'antd';

type ContactType = 'groom' | 'bride';
type ContactInfo = {
  name: string;
  phone: string;
  account: string;
};
const contactList: Record<ContactType, ContactInfo[]> = {
  groom: [
    {
      name: '한기욱',
      phone: '010-9097-3404',
      account: '신한 110-240-658938',
    },
    {
      name: '강시연',
      phone: '010-6288-3124',
      account: '지역농축협 21507751143670',
    },
    {
      name: '한도형',
      phone: '010-2739-5641',
      account: '기업 010-2739-5641',
    },
  ],
  bride: [
    {
      name: '심재은',
      phone: '010-3304-2047',
      account: '국민 010-3304-2047',
    },
    {
      name: '오세희',
      phone: '010-7568-8008',
      account: '농협 3560798599403',
    },
    {
      name: '심명보',
      phone: '010-4346-2004',
      account: '신한 110-508-829693',
    },
  ],
};

const Contact: FC = () => {
  const openModal = (isBride: boolean, contact: ContactInfo) => {
    Modal.confirm({
      icon: null,
      title: `${contact.name} ${isBride ? '(신부측)' : '(신랑측)'}`,
      content: (
        <div className={classes.modal}>
          <p>
            전화: <a href={`tel:${contact.phone}`}>{contact.phone}</a>
          </p>
          <p>계좌: {contact.account}</p>
        </div>
      ),
      cancelText: '닫기',
      okText: '계좌 번호 복사',
      okCancel: true,
      maskClosable: true,
      onOk: async () => {
        await navigator.clipboard.writeText(contact.account);
        message.success('복사되었습니다.');
      },
    });
  };

  return (
    <div className={classes.contactContainer}>
      <div className={classes.title}>
        <img src={Heart} alt="heart" />
        <h3>축하 연락 안내</h3>
      </div>
      <div className={classes.groupTitle}>
        <p>신랑측</p>
        <p>신부측</p>
      </div>
      <div className={classes.contactGroupBox}>
        <div className={classes.contactGroup}>
          {contactList.groom.map((contact, index) => (
            <Button
              size="large"
              key={`groom-contact-${index}`}
              onClick={() => openModal(false, contact)}
            >
              {contact.name}
            </Button>
          ))}
        </div>
        <div className={classes.contactGroup}>
          {contactList.bride.map((contact, index) => (
            <Button
              size="large"
              key={`bride-contact-${index}`}
              onClick={() => openModal(true, contact)}
            >
              {contact.name}
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Contact;
